export const uk = {
  nav: {
    features: "Можливості",
    stats: "Статистика",
    pricing: "Тарифи",
    gallery: "Інтерфейс",
    contacts: "Контакти",
    about: "Про нас",
    faq: "FAQ",
    auth: "Авторизуватися",
    logout: "Вийти"
  },
  hero: {
    badge: "Версія 2.0.1.0 • Стабільний реліз",
    title: "Telegram PRIME",
    subtitle: "Універсальний автоматизований комбайн для просування в Telegram. Потужні розсилки, інвайтинг, парсинг, чекери та автовідповідачі в один клік.",
    ctaStart: "Почати безкоштовно",
    ctaPricing: "Подивитися тарифи",
    ctaInterface: "Огляд інтерфейсу"
  },
  stats: {
    title: "НАША СПІЛЬНОТА ТА ДОСЯГНЕННЯ!",
    onlineUsers: "Користувачів онлайн",
    reviews: "Відгуків на форумах",
    community: "Наша спільнота на форумах",
    invites: "Інвайтів за весь час",
    messages: "Розіслано повідомлень"
  },
  features: {
    title: "ШИРОКИЙ ФУНКЦІОНАЛ КОМБАЙНА",
    subtitle: "Telegram PRIME містить все необхідне для комплексної роботи та просування в месенджері",
    showAll: "Показати всі функції",
    hideAll: "Приховати частину",
    items: {
      relogin: {
        title: "Релогін сесії",
        desc: "Дозволить з легкістю використовувати акаунти, одночасно підключаючись до них з різних місць."
      },
      s2td: {
        title: "Конвертер Session - Tdata",
        desc: "Конвертуйте свої сесії в TData для використання на Telegram Desktop."
      },
      td2s: {
        title: "Конвертер Tdata - Session",
        desc: "Конвертируйте свої TData в сесії для використання в нашій програмі."
      },
      warmup: {
        title: "Прогрів групи через ШІ",
        desc: "Запустіть свої акаунти в групу, задайте кожному партнера та тему для бесіди, і отримайте живу групу."
      },
      vtope: {
        title: "Автоматизація vTope",
        desc: "Підключайтеся до найбільшої мережі накрутки vTope та заробляйте на переглядах, реакціях та підписках."
      },
      automsg: {
        title: "Авто-вітання приєднавшихся",
        desc: "Використовуйте унікальну можливість першим перехопити свіжого клієнта в чаті."
      },
      autolike: {
        title: "Автореакції в каналі",
        desc: "З цією функцією Ви завжди будете першим, хто поставить реакцію на новий пост."
      },
      autocomment: {
        title: "Автокоментарі в каналах",
        desc: "Як правило, саме перші коментарі переглядають найчастіше, тож нехай він буде саме Вашим!"
      },
      checker: {
        title: "Чекер юзернеймів",
        desc: "Обробляйте свої бази логінів Телеграм швидко та легко для подальшої роботи з ними."
      },
      unblock: {
        title: "Зняття спамблоку",
        desc: "Відправляйте запити на зняття спамблоку з унікальними причинами, продовжуючи життя акаунтам."
      },
      admininvite: {
        title: "Інвайт через адмінку",
        desc: "Запрошуйте користувачів у групи через призначених адмінів, уникаючи банів самої групи."
      },
      reports: {
        title: "Масові скарги",
        desc: "Інструмент автоматичного надсилання масових скарг на Telegram групи, канали та ботів."
      },
      randomizer: {
        title: "Рандомізатор тексту 2.0",
        desc: "Коли спінтакс зустрічається з ШІ для досягнення максимальної унікальності та якості контенту."
      },
      stories: {
        title: "Робота з історіями",
        desc: "Масове створення історій на акаунтах, перегляд історій та буст для ваших каналів."
      },
      interceptor: {
        title: "Перехоплювач повідомлень",
        desc: "Захоплюйте та перенаправляйте вхідні повідомлення на льоту в реальному часі у будь-яке місце."
      },
      chatcloner: {
        title: "Клонер чатів",
        desc: "Сподобалася чужа група? Зробіть собі точно таку саму, включаючи оформлення та користувачів."
      },
      webchat: {
        title: "Веб-розгортка акаунта",
        desc: "Більше немає потреби перенесення в tdata! Відкривайте акаунти в браузері в реальному часі."
      },
      offerphoto: {
        title: "Запропонувати фото юзеру",
        desc: "Дозволяє масово пропонувати фото користувачам, розміщуючи на них свій рекламний оффер."
      },
      chancloner: {
        title: "Клонер каналів",
        desc: "Клонування Telegram каналів в реальному часі (по мірі виходу постів) або перенесення старих постів."
      },
      autoinvite: {
        title: "Авто-інвайт новеньких",
        desc: "Слідкуйте за чужою групою та автоматично запрошуйте всіх новоприбулих до свого чату."
      }
    }
  },
  details: {
    sectionTitle: "ЧОМУ TELEGRAM PRIME?",
    block1: {
      title: "Потужний інструмент маркетингу в Telegram",
      p1: "Приєднуйтесь до революції у світі цифрового просування вже сьогодні!",
      p2: "Наш інструмент дає вам унікальну можливість доставляти ваші рекламні повідомлення безпосередньо в телефони ваших потенційних клієнтів, взаємодіючи з окремими користувачами, мобільними номерами або всіма учасниками Телеграм-груп.",
      p3: "У нас немає обмежень на креативність: підтримуються всі формати оформлення тексту та надсилання аудіофайлів у форматі голосових повідомлень."
    },
    block2: {
      title: "Завоюйте світ швидких та ефективних результатів!",
      p1: "Масові розсилки в Телеграм - це найгучніший рупор просування. З Telegram PRIME ви можете здійснювати потужні рекламні кампанії без великих витрат.",
      p2: "Програма надає можливість цілеспрямовано фільтрувати аудиторію, залишаючи тільки живих та активних користувачів."
    },
    block3: {
      title: "Аналітика та збір аудиторії (Парсинг)",
      p1: "Збирайте цільову аудиторію з відкритих та закритих груп, коментарів на каналах та чатів.",
      p2: "Інноваційний збір за ключовими словами та детальна фільтрація за активністю користувача дозволяють відсіяти ботів."
    }
  },
  pricing: {
    title: "ТАРИФИ ТА ІНСТРУМЕНТИ",
    subtitle: "Виберіть необхідні модулі або додаткові сервіси для вашого бізнесу",
    tabModules: "Модулі програми",
    tabThirdParty: "Сторонній софт",
    tabPartners: "Послуги партнерів",
    buyCrypto: "Купити | Крипта",
    buyCard: "Купити Картою",
    askQuestion: "Задати Питання",
    eternal: "Вічний доступ",
    from: "від",
    modules: {
      cloner: {
        title: "КЛОНЕР КАНАЛІВ",
        price: "100 $",
        f1: "Вічний доступ - 100 $",
        f2: "Копіювання чужих каналів",
        f3: "Фільтрація заборонених слів",
        f4: "Заміна посилань на свої",
        f5: "Багатопотокова робота"
      },
      interceptor: {
        title: "ПЕРЕХОПЛЮВАЧ ПОВІДОМЛЕНЬ",
        price: "100 $",
        f1: "Вічний доступ - 100 $",
        f2: "Стеження за активністю акаунтів",
        f3: "Пошук ключових слів у реальному часі",
        f4: "Пересилання заявок у ваш бот/канал",
        f5: "Налаштування складних фраз"
      },
      warmup: {
        title: "ПРОГРІВАТОР АКАУНТІВ",
        price: "150 $",
        f1: "Вічний доступ - 150 $",
        f2: "Повна автоматизація діалогів",
        f3: "Прогрів через ШІ (ChatGPT)",
        f4: "Імітація живого спілкування в чатах",
        f5: "Налаштування затримок та лімітів"
      }
    },
    thirdParty: {
      checker: {
        title: "Чекер телефонних номерів",
        price: "40 $",
        desc: "Перевірка бази номерів на наявність Telegram з експортом ID, Premium статусу та Username."
      },
      converters: {
        title: "Конвертери акаунтів",
        price: "29 $",
        desc: "Конвертація між Session, Tdata, AuthKey, JSON у будь-яких напрямках з переавторизацією."
      },
      manager: {
        title: "Менеджер Web-Telegram",
        price: "40 $",
        desc: "Управління сіткою акаунтів через браузер, планувальник завдань, унікальні відбитки сесій."
      }
    },
    partners: {
      vps: {
        title: "Cloud VPS Сервери",
        price: "14 $ / міс",
        desc: "Анонімні Windows/Linux VPS, ідеально сумісні та налаштовані під роботу з TG Prime."
      },
      redirect: {
        title: "Stealth Redirect посилання",
        price: "15 $ / міс",
        desc: "Сервіс скорочення та маскування посилань із захистом від банів, підключенням доменів та аналітикою."
      },
      proxies: {
        title: "Приватні Проксі",
        price: "7.5 $ / міс",
        desc: "Мобільні та резидентські SOCKS5/HTTP проксі зі зміною IP за таймером або посиланням."
      }
    }
  },
  about: {
    title: "ПРО НАС",
    subtitle: "Команда, яка робить автоматизацію Telegram доступною та ефективною",
    lead: "Telegram PRIME - це офіційна платформа для продажу ліцензійних ключів Telegram Prime та модулів розширення.",
    story: "Ми працюємо з маркетингом у Telegram понад 5 років і об'єднали весь необхідний інструментарій в одній екосистемі. Наша мета - дати арбітражникам, SMM-фахівцям і власникам бізнесу надійний софт, прозорі ціни та оперативну підтримку. Кожен ключ активується в особистому кабінеті, а оновлення виходять регулярно і безкоштовно для всіх користувачів.",
    value1: {
      title: "Офіційні ключі",
      desc: "Купуйте ліцензії Telegram Prime безпосередньо через захищений особистий кабінет без посередників і націнок."
    },
    value2: {
      title: "Підтримка 24/7",
      desc: "Наша команда допомагає з активацією, налаштуванням модулів і HWID-прив'язкою в Telegram та через тикет-систему."
    },
    value3: {
      title: "Регулярні оновлення",
      desc: "Telegram постійно змінюється, тому ми випускаємо оновлення та фікси для стабільної роботи всіх функцій."
    },
    value4: {
      title: "Спільнота професіоналів",
      desc: "Приєднуйтесь до чату користувачів, де діляться кейсами, новими схемами та допомогою по роботі з софтом."
    },
    tag: "Офіційний реселлер",
    stat1: { label: "Років на ринку" },
    stat2: { label: "Модулів" },
    stat3: { label: "Підтримка" },
    ctaTitle: "Залишилися питання?",
    ctaText: "Напишіть нам на email - допоможемо з вибором модуля, активацією та налаштуванням.",
    ctaButton: "Email"
  },
  faq: {
    title: "ЧАСТІ ПИТАННЯ",
    subtitle: "Відповіді на найпопулярніші питання про купівлю, активацію та роботу Telegram Prime",
    q1: "Що таке Telegram Prime і навіщо потрібен ключ?",
    a1: "Telegram Prime - це комплексне ПЗ для автоматизації просування в Telegram: розсилки, інвайтинг, парсинг, клонування та багато іншого. Ліцензійний ключ відкриває доступ до особистого кабінету та обраних модулів.",
    q2: "Як купити ключ Telegram Prime?",
    a2: "Виберіть відповідний тариф або модуль, натисніть «Купити» та оплатіть криптовалютою. Після підтвердження оплати ключ одразу з'явиться у вашому особистому кабінеті.",
    q3: "У чому різниця між демо, місячним і вічним ключем?",
    a3: "Демо-ключ видається на 3 дні і підходить для тестування. Місячний ключ працює 30 днів. Вічний ключ дає пожиттєвий доступ до базової ліцензії та безкоштовних оновлень.",
    q4: "Що робити, якщо змінився комп'ютер або залізо?",
    a4: "В особистому кабінеті доступний скидання HWID-прив'язки. Він дозволяє перенести активований ключ на новий ПК. Для демо-ключа скидання недоступне.",
    q5: "Чи можна додати модулі після покупки ключа?",
    a5: "Так, будь-який модуль можна докупити окремо в особистому кабінеті. Він одразу прив'яжеться до вашого поточного ключа та активується автоматично.",
    q6: "Які способи оплати доступні?",
    a6: "Ми приймаємо тільки криптовалюту. Реквізити для оплати відображаються при оформленні покупки в особистому кабінеті.",
    q7: "Чи є повернення коштів після покупки ключа?",
    a7: "Цифрові ключі та модулі поверненню не підлягають, якщо вони вже були активовані. До покупки рекомендуємо скористатися безкоштовним демо-періодом.",
    q8: "Куди звертатися за допомогою?",
    a8: "Напишіть нам в онлайн-чат - середній час відповіді від кількох хвилин до пари годин.",
    q9: "Чи можна купити модуль окремо від ядра програми?",
    a9: "Так, будь-який модуль можна придбати окремо. Вам не обов'язково купувати базову ліцензію, якщо потрібен лише конкретний функціонал. Модуль активується в особистому кабінеті та прив'язується до вашого HWID."
  },
  auth: {
    login: "Увійти",
    register: "Реєстрація",
    email: "Email адреса",
    password: "Пароль",
    username: "Ім'я користувача",
    confirmPassword: "Підтвердіть пароль",
    submitLogin: "Авторизуватися",
    submitRegister: "Створити акаунт",
    noAccount: "Ще немає акаунта?",
    haveAccount: "Вже є акаунт?",
    title: "Особистий кабінет Telegram Prime",
    close: "Закрити",
    successMsg: "Ви успішно авторизувалися!",
    welcome: "Ласкаво просимо до панелі керування!",
    captchaRequired: "Будь ласка, підтвердьте, що ви не робот.",
    or: "або",
    googleLogin: "Увійти через Google",
    fillAllFields: "Будь ласка, заповніть всі поля.",
    passwordMismatch: "Паролі не збігаються!",
    passwordWeak: "Пароль занадто простий!",
    registerSuccess: "Реєстрація успішна! Будь ласка, увійдіть в аккаунт.",
    passwordStrengthWeak: "Слабкий",
    passwordStrengthMedium: "Середній",
    passwordStrengthStrong: "Надійний",
    errorUnknown: "Сталася помилка",
    verifyTitle: "Підтвердження пошти",
    verifyIntro: "Ми надіслали 6-значний код на {email}. Введіть його, щоб завершити реєстрацію. Акаунт створюється лише після підтвердження.",
    verifyLoginTitle: "Підтвердження входу",
    verifyLoginIntro: "Виявлено вхід з нової IP-адреси. Ми надіслали код на {email}. Введіть його, щоб підтвердити вхід.",
    codeLabel: "Код підтвердження",
    codePlaceholder: "6-значний код",
    confirmCode: "Підтвердити",
    resendCode: "Надіслати код повторно",
    resendIn: "Надіслати повторно через {seconds} с",
    changeEmail: "Назад",
    codeRequired: "Введіть код підтвердження.",
    devCodeNotice: "Режим розробки (надсилання листів вимкнено), ваш код: {code}"
  },
  gallery: {
    title: "ЗРУЧНИЙ ІНТЕРФЕЙС ПРОГРАМИ",
    subtitle: "Скріншоти робочої панелі керування та модулів Telegram PRIME"
  },
  footer: {
    desc: "Telegram PRIME - професійне ПЗ для лідогенерації та автоматизації в месенджері Telegram. Всі права захищені.",
    community: "Приєднуйтесь до спільноти",
    support: "Технічна підтримка працює Пн-Пт 08:00 - 20:00 (GMT+2)."
  },
  dashboard: {
    download: "Завантажити Telegram Prime",
    title: "ПАРАМЕТРИ СИСТЕМИ",
    modulesTitle: "КЕРУВАННЯ ЗБІРКОЮ",
    newsTitle: "БОРТОВИЙ ЖУРНАЛ",
    license: "Моя ліцензія",
    shop: "Вітрина модулів",
    changelog: "Бортовий журнал",
    referral: "Реферальна система",
    faq: "Питання та відповіді",
    keyInfo: "Ліцензійний Ключ",
    activated: "АКТИВОВАНИЙ",
    notActivated: "НЕ АКТИВОВАНИЙ",
    hwidLinked: "Прив'язаний до ПК",
    hwidFree: "Вільний / Скинутий",
    resetHwid: "Скинути прив'язку (HWID Reset)",
    activatePc: "Активувати на цьому ПК",
    activeComponents: "Активні компоненти",
    installed: "Придбано",
    buy: "Купити",
    select: "Вибрати",
    free: "Безкоштовно",
    activateFree: "Активувати безкоштовно",
    linkKeyFirst: "Помилка! Спочатку прив'яжіть ключ.",
    selectLicensePlan: "Виберіть тарифний план для генерації ліцензійного ключа:",
    demoPeriod: "На 3 дні",
    monthlyPeriod: "На 30 днів",
    permanentPeriod: "Назавжди",
    payWithCrypto: "СПЛАТИТИ КРИПТОЮ",
    transaction: "ЗАПИТ НА ТРАНЗАКЦІЮ",
    selectLicenseType: "Виберіть тип ліцензії",
    billingFor: "Шлюз оплати для:",
    abort: "Перервати операцію",
    blocked: "ЗАБЛОКОВАНА",
    expired: "ЗАКІНЧИЛАСЬ",
    licenseKey: "Ліцензійний Ключ",
    licenseType: "Тип",
    expiresAt: "Закінчується",
    activeModulesCount: "Активних модулів",
    active: "Активних",
    lifetime: "Вічний",
    deleteKey: "Видалити ключ",
    upgradeToPermanent: "Апгрейд до вічного",
    upgradeToMonthly: "Апгрейд до місячного",
    extendLicense: "Продовжити ліцензію",
    licenseBlockedContactSupport: "Ліцензію заблоковано. Зверніться до підтримки.",
    noLicenseMessage: "У вас поки немає активної ліцензії. Виберіть тарифний план, щоб почати роботу.",
    buyLicenseOrDemo: "Купити ліцензію / Взяти Демо",
    ready: "ГОТОВО",
    noActiveModules: "Немає активних модулів",
    copyKey: "Копіювати ключ",
    copied: "Скопійовано!",
    referralTitle: "Реферальна система",
    referralCode: "Ваш реферальний код",
    referralBalance: "Реферальний баланс",
    referralHowItWorks: "Як це працює:",
    referralStep1: "Скопіюйте ваш персональний код.",
    referralStep2: "Поділіться кодом з другом або в рекламі.",
    referralStep2Link: "Діліться реферальним посиланням — усі переходи за ним рахуються автоматично.",
    referralStep3: "Покупець отримує знижку {percent}% на платний ключ.",
    referralStep4: "Ви отримуєте {percent}% від покупки на баланс.",
    referralDemoInfo: "Знижка {percent}% застосовується тільки до платних ключів. Для демо-ключа реферальний код недоступний.",
    referralLinkLabel: "Ваше реферальне посилання",
    referralLinkCopied: "Реферальне посилання скопійовано!",
    referralLinkHint: "Кожен, хто перейде за цим посиланням, автоматично отримає ваш реферальний код — промокод вводити не потрібно.",
    referralClicks: "Переходи за посиланням",
    faqTitle: "Часті питання",
    faqEmpty: "Запитання та відповіді тимчасово недоступні.",
    referralTagline: "Заробляйте разом з Telegram Prime ❤️",
    applyReferralCode: "Застосувати реферальний код",
    referralCodePlaceholder: "Введіть реферальний код",
    referralHint: "Введіть реферальний код перед покупкою, щоб отримати знижку на платний ключ.",
    apply: "Застосувати",
    referralCodeApplied: "Реферальний код застосовано - знижка {percent}%",
    referralCodeInvalid: "Реферальний код недійсний",
    referralCodeCopied: "Реферальний код скопійовано!",
    applyPromoCode: "У мене є промокод",
    promoCodePlaceholder: "Введіть промокод",
    promoHint: "Введіть промокод перед покупкою, щоб отримати додаткову знижку. Знижки за промокодом і реферальним кодом сумуються.",
    promoCodeApplied: "Промокод застосовано - знижка {percent}%",
    promoCodeInvalid: "Промокод не знайдено або не активний",
    referralTransactions: "Реферальні нарахування",
    referralEarning: "Нарахування",
    referralNoTransactions: "Поки що немає реферальних нарахувань.",
    messages: {
      demoResetDisabled: "Скидання HWID недоступне для демо-ключа",
      keyNotBound: "Ключ не прив'язаний до пристрою",
      licenseExpired: "Ліцензія закінчилася. Спочатку продовжте її.",
      licenseBlocked: "Ліцензію заблоковано",
      hwidResetSuccess: "Прив'язку HWID успішно скинуто!",
      tooManyRequests: "Занадто багато запитів. Зачекайте 24 години.",
      hwidResetFailed: "Не вдалося скинути HWID",
      networkError: "Помилка мережі",
      confirmDeleteKey: "Ви впевнені, що хочете видалити ключ? Цю дію не можна скасувати.",
      keyDeletedSuccess: "Ключ успішно видалено!",
      keyDeleteFailed: "Не вдалося видалити ключ",
      redirectingToPayment: "Перенаправлення на оплату...",
      upgradeRequestSent: "Запит на апгрейд надіслано!",
      upgradeRequestFailed: "Не вдалося надіслати запит на апгрейд",
      extensionRequestSent: "Запит на продовження надіслано!",
      extensionRequestFailed: "Не вдалося надіслати запит на продовження",
      demoModulesAdded: "Модулі безкоштовно додано на демо-ключ",
      demoModulesFailed: "Не вдалося додати модулі на демо-ключ",
      copyKeySuccess: "Ключ скопійовано в буфер обміну",
      copyKeyFailed: "Не вдалося скопіювати ключ"
    }
  },
  license: {
    success: {
      demo_activated: "Демо-ключ успішно активовано"
    }
  },
  cabinetFaq: {
    subtitle: "Часті питання та відповіді про роботу з ліцензією та модулями",
    q1: "Як активувати придбаний ключ?",
    a1: "Після оплати ключ з'явиться у вашому особистому кабінеті на вкладці «Моя ліцензія». Натисніть «Активувати на цьому ПК», щоб прив'язати HWID.",
    q2: "Що таке HWID і навіщо він потрібен?",
    a2: "HWID - це унікальний ідентифікатор вашого комп'ютера. Він захищає ключ від передачі третім особам. Прив'язка здійснюється автоматично при активації.",
    q3: "Як скинути HWID, якщо я змінив комп'ютер?",
    a3: "В особистому кабінеті на вкладці «Моя ліцензія» натисніть «Скинути прив'язку (HWID Reset)». Скидання доступне не частіше разу на 24 години. Для демо-ключа скидання недоступне.",
    q4: "Як купити додатковий модуль?",
    a4: "Перейдіть на вкладку «Вітрина модулів», виберіть потрібний модуль і натисніть «Купити». Після оплати модуль автоматично прив'яжеться до вашого ключа.",
    q5: "Чи можна використовувати один ключ на декількох ПК?",
    a5: "Ні, один ключ може бути активований лише на одному ПК одночасно. Для перенесення використовуйте скидання HWID.",
    q6: "Де завантажити Telegram Prime?",
    a6: "Посилання для завантаження знаходиться у верхній частині особистого кабінету - кнопка «Завантажити Telegram Prime».",
    q7: "Як застосувати реферальний код?",
    a7: "В особистому кабінеті є блок «Реферальна система». Введіть код у поле перед покупкою платного ключа, і знижка автоматично застосується.",
    q8: "Що робити, якщо ліцензія закінчилася?",
    a8: "На вкладці «Моя ліцензія» виберіть «Продовжити ліцензію» або «Апгрейд до вічного». Після оплати доступ відновиться.",
    q9: "Що робити, якщо ключ заблоковано?",
    a9: "Якщо ви бачите статус «Заблокована», зверніться до технічної підтримки. Блокування може бути пов'язане з порушенням правил використання.",
    q10: "Чому модуль не з'явився після оплати?",
    a10: "Перевірте статус платежу в особистому кабінеті. Якщо кошти списані, але модуль не додано, зверніться до підтримки з номером транзакції.",
    supportTitle: "Не знайшли відповідь?",
    supportText: "Напишіть нам в онлайн-чат - допоможемо розібратися з активацією, модулями та оплатою.",
    emailBtn: "Email",
    telegramBtn: "Telegram"
  },
  modules: {
    module_1: {
      name: "Клонер чатів",
      features: [
        "Вічний доступ - 345 $",
        "Збір історії чатів",
        "Підготовка акаунтів",
        "Редактор повідомлень, редагуйте історію, як вам потрібно",
        "Постінг історії за інтервалами або як в оригіналі",
        "Отримуєте копію групи конкурента",
        "Повернення коштів не передбачено"
      ]
    },
    module_2: {
      name: "Репортер",
      features: [
        "Вічний доступ - 175 $",
        "Можливість заблокувати канал конкурента",
        "Можливість заблокувати групу конкурентів",
        "Можливість заблокувати бота ТГ",
        "Скарги через інвайтинг у чати",
        "Багатопотокова робота",
        "Повернення коштів не передбачено"
      ]
    },
    module_3: {
      name: "Клонер каналів",
      features: [
        "Вічний доступ - 105 $",
        "Автономне наповнення каналів",
        "Заміна ключових слів та посилань",
        "Клонер старих постів",
        "Виключення небажаного контенту та додавання свого",
        "Багатопотокова робота для отримання швидких результатів",
        "Повернення коштів не передбачено"
      ]
    },
    module_4: {
      name: "Перехватник повідомлень",
      features: [
        "Вічний доступ - 100 $",
        "Слідкує за всім, що відбувається на обліковому записі",
        "Пошук ключових слів у чатах у режимі реального часу",
        "Багатопотокова робота",
        "Пересилайте заявки куди вам потрібно (канал, бот або обліковий запис)",
        "Використовуйте ключові слова або фрази",
        "Повернення коштів не передбачено"
      ]
    },
    module_5: {
      name: "Прогреватор акаунтів",
      features: [
        "Вічний доступ - 150 $",
        "Повністю автоматизована робота модуля",
        "Прогрів через безліч автоматично виконуваних дій",
        "Управління кількістю завдань, що виконуються",
        "Унікалізація тексту через ІІ",
        "Багатопотокова робота з налаштуванням затримок між діями",
        "Повернення коштів не передбачено"
      ]
    }
  },
  news: {
    error: "Не вдалося завантажити оновлення",
    noUpdates: "Немає доступних оновлень",
    loading: "Завантаження оновлень...",
    latestUpdate: "ОСТАННЄ ОНОВЛЕННЯ",
    version: "ВЕРСІЯ",
    update: "ОНОВЛЕННЯ"
  }
};
